import * as React from "react";
import { UseQueryResult } from "react-query";

import Loading from "../Loading";
import ErrorMessage from "./ErrorMessge";

export type AsyncProps<P = any> = UseQueryResult<P, unknown> & {
  children?: ((props: { data?: P }) => JSX.Element) | JSX.Element;
};

function Async<P = any>({ isLoading, isError, data, children }: AsyncProps<P>) {
  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <ErrorMessage />;
  }

  if (typeof children === "function") {
    return children({ data });
  }

  return children ? children : <React.Fragment />;
}

export default Async;
